import React from 'react';

import { DEFAULT_NULL_VALUE } from '@/src/components/project/Inbox2/Config/inbox.config';

import FormattedDate from '../FormattedDate/FormattedDate';

export const DATE_FORMAT = 'DD-MMM YYYY hh:m A';

const FormattedDateWithUser = ({ date, userName }) => {
  const content = date;

  if (!content) {
    return DEFAULT_NULL_VALUE;
  }

  if (content === DEFAULT_NULL_VALUE) {
    return content;
  }

  return (
    <React.Fragment>
      <FormattedDate value={date} format={DATE_FORMAT} /> by {userName}
    </React.Fragment>
  );
};

export default FormattedDateWithUser;
